<ion-app style="background: none transparent;">
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" class="app-sidemenu">
      <ion-content contentId="main-content">
        <ion-row class="user-details-wrapper">
          <ion-col size="4">
            <app-aspect-ratio [ratio]="{w: 1, h: 1}">
              <app-image-shell [src]="'../assets/icon/favicon.png'"></app-image-shell>
            </app-aspect-ratio>
          </ion-col>
          <ion-col class="user-info-wrapper" size="8">
            <h3 class="user-name">Личный Кабинет</h3>
            <h5 class="user-handle">Версия 4.1.0</h5>
          </ion-col>
        </ion-row>

        <ion-list>
          <ion-list-header>Мои устройства</ion-list-header>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages$ | async">
          <!-- <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages"> -->
            <ion-item [routerDirection]="'root'" [routerLink]="p.url">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list *ngIf="user.userInfo != null && !user.userInfo.affiliated">
          <ion-list-header>Личный Кабинет</ion-list-header>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of accountPages">
            <ion-item [routerDirection]="'root'" [routerLink]="p.url">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list *ngIf="user.userInfo != null && !user.userInfo.affiliated && !(user.userInfo.isLegalEntity || user.userInfo.vip)">
          <ion-list-header>Финансы</ion-list-header>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of financePages">
            <ion-item [routerDirection]="'root'" [routerLink]="p.url">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list>
          <ion-list-header>Прочее</ion-list-header>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of otherPages; let i = index">
            <ion-item [routerDirection]="'root'" [routerLink]="p.url">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item [routerDirection]="'root'" [routerLink]="[]" (click)="logout()">
            <ion-icon slot="start" name="log-out"></ion-icon>
            <ion-label>
              Выход
            </ion-label>
          </ion-item>
        </ion-list>

      </ion-content>
    </ion-menu>
    <!-- Main app content get's rendered in this router-outlet -->
    <ion-router-outlet id="main-content" #content main></ion-router-outlet>
  </ion-split-pane>
</ion-app>
